var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "aria-hidden": "true",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1249 0.688252C22.3202 0.271748 19.3537 0 16 0C12.6463 0 9.6798 0.271748 7.87511 0.688252C4.27689 1.44332 1.44332 4.27689 0.688252 7.87511C0.271748 9.6798 0 12.6463 0 16C0 19.3537 0.271748 22.3202 0.688252 24.1249C1.44332 27.7231 4.27689 30.5567 7.87511 31.3117C9.6798 31.7283 12.6463 32 16 32C19.3537 32 22.3202 31.7283 24.1249 31.3117C27.7231 30.5567 30.5567 27.7231 31.3117 24.1249C31.7283 22.3202 32 19.3537 32 16C32 12.6463 31.7283 9.6798 31.3117 7.87511C30.5567 4.27689 27.7231 1.44332 24.1249 0.688252Z",
    fill: "#00B388"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04963 13.8125C6.48461 9.72885 9.72885 6.48461 13.8125 6.04963C14.1205 6.01683 14.4333 6 14.75 6V14.75H6C6 14.4333 6.01683 14.1205 6.04963 13.8125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.78125C15.7411 6.78125 15.5312 6.99112 15.5312 7.25C15.5312 8.72882 15.4688 12.8684 15.5 15.5C13.8125 15.5312 11.4921 15.5312 7.25 15.5312C6.99112 15.5312 6.78125 15.7411 6.78125 16C6.78125 21.0914 10.9086 25.2188 16 25.2188C21.0914 25.2188 25.2188 21.0914 25.2188 16C25.2188 10.9086 21.0914 6.78125 16 6.78125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIcon);
export default __webpack_public_path__ + "static/media/stats_icon.0adc48425542ef07b41c1cb0d30e73da.svg";
export { ForwardRef as ReactComponent };